{
  "hero": {
    "eyebrow": "Rejoindre",
    "title": "Développez des compétences de surveillance sur un vrai défi de durabilité campus.",
    "lead": "Des étudiants en mécanique, électricité, logiciel et affaires planifient, conçoivent, testent, documentent et communiquent AquaWorks ensemble."
  },
  "paths": {
    "title": "Façons de participer",
    "items": {
      "students": {
        "title": "Rejoindre comme étudiant",
        "body": "Contribuez aux filières Logiciel, Électricité, Mécanique ou Affaires — de la CAO et des circuits à la visualisation, aux achats et aux rapports."
      },
      "partners": {
        "title": "Conseiller ou collaborer",
        "body": "Professeurs, laboratoires et partenaires campus peuvent guider méthodes, faisabilité de site et communication responsable. Nous consultons déjà Campus and Community Planning et des enseignants en génie civil."
      },
      "public": {
        "title": "Suivre la construction",
        "body": "Lisez les Actualités pour les jalons, explorez Science pour les indicateurs et le contexte campus, ou surveillez de futures démos ouvertes après les essais contrôlés."
      }
    }
  },
  "contacts": {
    "title": "Contacts principaux",
    "body": "Contactez les responsables de projet pour l'intégration, la collaboration ou les questions Phase 1.",
    "items": [
      {
        "name": "Jiaming Han",
        "role": "Chef de projet · Faculty of Applied Science",
        "email": "jhan31@student.ubc.ca"
      },
      {
        "name": "Lucas Lyu",
        "role": "Co-chef de projet · Faculty of Applied Science",
        "email": "lyuchongkai@gmail.com"
      }
    ],
    "note": "Seuls les e-mails des responsables de projet sont publiés. Téléphones et numéros d'étudiant ne le sont pas."
  }
}
